import { Avatar, AvatarBadgeColor, AvatarSize } from '@amzn/stencil-react-components/avatar';
import { View } from '@amzn/stencil-react-components/layout';
import { Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import { BaseballCardEmployee } from 'src/api/interfaces';

interface HorizontalUserAvatarProps {
  userInfo: BaseballCardEmployee;
  avatarSize?: AvatarSize;
  badgeColor?: string;
  stack: boolean;
  showAdditionalInfo?: boolean;
}

const BaseballCardEmployeeUserAvatar: React.FC<HorizontalUserAvatarProps> = ({
  userInfo,
  avatarSize = AvatarSize.Large,
  badgeColor,
  stack = true,
  showAdditionalInfo = true
}) => {
  const convertedBadgeColor = badgeColor === 'orange' ? AvatarBadgeColor.Yellow : (badgeColor as AvatarBadgeColor);

  const jobInfo = `${userInfo.jobTitle} • L${userInfo.jobLevel}`;
  const locationInfo = `${userInfo.city}, ${userInfo.country}`;
  const fullName = `${userInfo.firstName} ${userInfo.lastName}`;

  return (
    <View data-avatar-id={`avatar-${userInfo.login}`}>
      <Avatar
        username={userInfo.login}
        fullName={fullName}
        badgeColor={convertedBadgeColor}
        size={avatarSize}
        imageAltText={`Profile image of ${fullName}`}
      >
        {showAdditionalInfo &&
          (stack ? (
            <View>
              <Text fontSize="T200" lineHeight="T200">
                {jobInfo}
              </Text>
              <Text fontSize="T200" lineHeight="T200">
                {userInfo.costCenterName} • {locationInfo}
              </Text>
            </View>
          ) : (
            <View>
              <Text fontSize="T200" lineHeight="T200">
                {jobInfo} • {userInfo.costCenterName} • {locationInfo}
              </Text>
            </View>
          ))}
      </Avatar>
    </View>
  );
};

export default BaseballCardEmployeeUserAvatar;
